import { jsx as i, jsxs as l, Fragment as L } from "react/jsx-runtime";
import { useBreakpoint as P, NextgenImage as g, LoaderType as v, GenericLink as E, FAIcon as k, Theme as y, IconStyle as K } from "@nextgen-web-framework/all";
import { getThemeColorClass as D, ThemeColor as B } from "../../utils/themeColor.js";
import { s as c } from "../../ContentCard.module-2ab88d65.mjs";
import { Icons as d } from "../ContentCard/types/propsTypes.js";
import { ResourceType as n } from "./types/propsTypes.js";
const W = (e) => {
  var h, T, N, f;
  const C = P(), w = ConfigService.getConfigs().NEXT_ASSETS_BASE_PATH, t = (h = e == null ? void 0 : e.imageList) == null ? void 0 : h.find((a) => {
    var r;
    return (r = a == null ? void 0 : a.viewport) == null ? void 0 : r.includes(C);
  }), s = e.themeShade ? D(B.gray, e.themeShade) : void 0, S = s || `card-bg-color-${e.backgroundColor || "white"}`, $ = s ? "card-color-black" : `card-color-${e.color || "black"}`, m = (() => {
    let a = "";
    switch (e.resourceType) {
      case n.image:
        a = d.Image;
        break;
      case n.pdf:
        a = d.PDF;
        break;
      case n.video:
        a = d.Video;
        break;
      case n.audio:
        a = d.Audio;
        break;
    }
    return a;
  })(), A = (T = e.link) != null && T.url ? (N = e.link) == null ? void 0 : N.url : t == null ? void 0 : t.url, o = () => {
    var a;
    if (!e.detailPage) {
      const r = e.resourceType === n.image ? A : (a = e.link) == null ? void 0 : a.url;
      r && window.open(r, "_blank", "noopener,noreferrer");
    }
  }, u = () => (e.resourceType === n.audio || (t == null ? void 0 : t.url)) && /* @__PURE__ */ i(
    g,
    {
      src: x(),
      alt: (t == null ? void 0 : t.altText) ?? "",
      className: c["content-card-image"],
      loaderType: v.CONTENTSTACK
    }
  ), x = () => e.resourceType === n.audio ? `${w}/images/MusicResource.svg` : (t == null ? void 0 : t.url) ?? "";
  return /* @__PURE__ */ i(
    "div",
    {
      className: c["content-card-link"],
      role: "presentation",
      onClick: o,
      onKeyDown: () => o,
      children: /* @__PURE__ */ l(
        "div",
        {
          className: `${c["content-card-container"]}  ${c["resource-card-container"]} ${e.customClass}`,
          "data-testid": `resource-${e.resourceType}-card-container-testid`,
          children: [
            /* @__PURE__ */ l("div", { className: c.banner, children: [
              e.resourceType === n.pdf ? /* @__PURE__ */ i("div", { className: c["pdf-banner"], "data-testid": "resource-pdf-img-testid", "data-pod-name": "commerce", children: /* @__PURE__ */ i("div", { className: c["pdf-banner-wrapper"], children: /* @__PURE__ */ i("div", { className: c["pdf-banner-inner"], children: (t == null ? void 0 : t.url) && /* @__PURE__ */ i(
                g,
                {
                  src: (t == null ? void 0 : t.url) ?? "",
                  alt: (t == null ? void 0 : t.altText) ?? "",
                  className: c["content-card-image"],
                  loaderType: v.CONTENTSTACK
                }
              ) }) }) }) : /* @__PURE__ */ i(L, { children: e.detailPage ? /* @__PURE__ */ i(E, { href: e.url ?? "", target: (f = e == null ? void 0 : e.link) == null ? void 0 : f.target, children: u() }) : /* @__PURE__ */ i("div", { children: u() }) }),
              m && /* @__PURE__ */ i(
                "div",
                {
                  className: c["icon-container"],
                  "data-testid": "content-type-icon-testid",
                  "data-pod-name": "commerce",
                  role: "presentation",
                  onClick: () => o,
                  onKeyDown: () => o,
                  children: /* @__PURE__ */ i(k, { iconName: m, theme: y.WHITE, iconStyle: K.SOLID })
                }
              ),
              !e.detailPage && /* @__PURE__ */ i(
                "div",
                {
                  className: c["download-icon-container"],
                  "data-testid": "download-icon-testid",
                  "data-pod-name": "commerce",
                  role: "presentation",
                  onClick: () => o,
                  onKeyDown: () => o,
                  children: /* @__PURE__ */ i(k, { iconName: "arrow-down-to-line", theme: y.BLACK })
                }
              )
            ] }),
            /* @__PURE__ */ l("div", { className: `${c.content} ${c[S]} ${c["resource-card-content"]}`, children: [
              /* @__PURE__ */ l("div", { className: `${c.header} ${c[$]}`, children: [
                /* @__PURE__ */ i("div", { className: `${c.tag}`, children: e.tag }),
                e.title && /* @__PURE__ */ i("div", { className: c.title, title: e.title, children: e.title })
              ] }),
              /* @__PURE__ */ i("div", { className: c.footer, children: e.subTitle && /* @__PURE__ */ i("div", { className: c["footer-line"], children: e.subTitle }) })
            ] })
          ]
        }
      )
    }
  );
};
export {
  W as default
};
//# sourceMappingURL=ResourceCard.js.map
